import { Helmet } from "react-helmet-async";
import DisclaimerBanner from "@/components/DisclaimerBanner";
import StickyHeader from "@/components/StickyHeader";
import HeroSection from "@/components/HeroSection";
import ProductContentSection from "@/components/ProductContentSection";
import TrustBadges from "@/components/TrustBadges";

import ScientificStudiesSection from "@/components/ScientificStudiesSection";
import ProblemSection from "@/components/ProblemSection";
import PreviewSection from "@/components/PreviewSection";
import FAQSection from "@/components/FAQSection";
import FinalCTASection from "@/components/FinalCTASection";
import FloatingCTA from "@/components/FloatingCTA";
import CookieConsent from "@/components/CookieConsent";
import Footer from "@/components/Footer";
import WaveDivider from "@/components/WaveDivider";
import ScrollProgressBar from "@/components/ScrollProgressBar";
import CursorGlow from "@/components/CursorGlow";
import { useScrollTracking } from "@/hooks/useScrollTracking";

const Index = () => {
  useScrollTracking({
    thresholds: [25, 50, 75, 100],
    onThresholdReached: (threshold) => {}
  });

  return (
    <>
      <Helmet>
        <title>Naturkraft: Die vier Säulen der Vitalität | 150+ Naturmittel A-Z | 600+ Seiten PDF</title>
        <meta name="description" content="Die wertvollste Investition in Ihre Gesundheit: Vitamin D3, OPC, Vitamin C & Mineralien. 150+ natürliche Mittel von Bärlauch bis Zink, über 200 Beschwerden natürlich unterstützen." />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.love-the-nature.de/" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "Wie bekomme ich das PDF nach dem Kauf?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Sofort nach der Zahlung erhalten Sie den Download-Link per E-Mail (auch im Spam-Ordner nachsehen). Der Download funktioniert auf allen Geräten - PC, Tablet, Smartphone. Sie können es unbegrenzt oft herunterladen."
                }
              },
              {
                "@type": "Question",
                "name": "Funktioniert das PDF auf dem Handy/Tablet?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Ja, absolut! Das PDF ist optimiert für alle Geräte - iPhone, iPad, Android-Smartphones und -Tablets. Sie können es mit jedem PDF-Reader öffnen (z.B. Adobe Reader, Apple Books, Google PDF Viewer)."
                }
              },
              {
                "@type": "Question",
                "name": "Welche Zahlungsmethoden werden akzeptiert?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Sie können per Kreditkarte (Visa, Mastercard, American Express), PayPal, Apple Pay, Google Pay oder Klarna bezahlen. Die Zahlung wird über Payhip abgewickelt - sicher und SSL-verschlüsselt."
                }
              },
              {
                "@type": "Question",
                "name": "Was wenn es mir nicht gefällt?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Sie haben 14 Tage Geld-zurück-Garantie ohne Wenn und Aber. Einfach eine E-Mail und Sie erhalten Ihr Geld zurück. Kein Risiko für Sie."
                }
              },
              {
                "@type": "Question",
                "name": "Ist das wissenschaftlich fundiert?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Ja. Das Quellenverzeichnis umfasst 200+ Studien auf Seite 560-600 mit PubMed-Links, ISBN-Nummern und peer-reviewed Journals. Jedes Naturmittel basiert auf wissenschaftlicher Evidenz oder jahrhundertelanger traditioneller Anwendung."
                }
              },
              {
                "@type": "Question",
                "name": "Ersetzt das den Arzt?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Nein. Bei ernsthaften oder unklaren Symptomen steht im Buch explizit: 'Zum Arzt!'. Dieses Buch ist Bildung und Information, keine medizinische Beratung. Es ergänzt die Schulmedizin, ersetzt sie nicht."
                }
              },
              {
                "@type": "Question",
                "name": "Kann ich das auch ohne Vorkenntnisse verstehen?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Ja. Alle Fachbegriffe werden erklärt. Das Buch ist für Laien geschrieben – verständlich, aber wissenschaftlich korrekt. Das Inhaltsverzeichnis ermöglicht schnelles Finden des richtigen Mittels."
                }
              }
            ]
          })}
        </script>
      </Helmet>
      <div className="min-h-screen relative">
      <ScrollProgressBar />
      <CursorGlow />
      <DisclaimerBanner />
      <StickyHeader />
      <main>
        <HeroSection />
        
        <ProductContentSection />
        
        <TrustBadges />
        
        
        
        <div className="relative h-[60px] md:h-[100px]">
          <WaveDivider variant="bottom" />
        </div>
        <ScientificStudiesSection />
        
        <div className="relative h-[60px] md:h-[100px]">
          <WaveDivider variant="bottom" flip />
        </div>
        <ProblemSection />
        
        <div className="relative h-[60px] md:h-[100px]">
          <WaveDivider variant="bottom" />
        </div>
        <PreviewSection />
        
        <div className="relative h-[60px] md:h-[100px]">
          <WaveDivider variant="bottom" flip />
        </div>
        <FAQSection />
        
        <FinalCTASection />
      </main>
      
      <FloatingCTA />
      <CookieConsent />
      
      <Footer />
      </div>
    </>
  );
};

export default Index;
